import TransformHelper from '../helpers/TransformHelper';
import {
  ICustomerDataSheet,
  ICustomerDataSheetStatusData,
  IDataSheetOrder,
  IDatasheetOrdersFilter,
} from '../common/interfaces/customers.interface';
import DatasheetHelper from '../helpers/DatasheetHelper';
import { IUplineData } from '../common/interfaces/partners.interface';
import config from '../../config';
import ZApiService from './ZApiService';

export default class CustomersService {
  private zapiService: ZApiService;

  constructor(zApiService: ZApiService) {
    this.zapiService = zApiService;
  }

  public async getCustomerDatasheet(customerNumber: number): Promise<ICustomerDataSheet> {
    const data = await this.zapiService.getCustomerDatasheet(customerNumber);
    return TransformHelper.transformApiCustomerDataSheetToCustomerDataSheet(data);
  }

  public async transferCustomer(customerNumber: number, target: number): Promise<void> {
    return this.zapiService.transferCustomer(customerNumber, target);
  }

  public suggestAsPartner(customerNumber: number): Promise<void> {
    return this.zapiService.suggestAsPartner(customerNumber);
  }

  public async getStatusData(customerData: ICustomerDataSheet): Promise<ICustomerDataSheetStatusData> {
    let fairScore: number | undefined;
    let upline: IUplineData[] | undefined;

    if(customerData.partner) {
      [
        fairScore,
        upline,
      ] = await Promise.all([
        this.zapiService.getFairScore(customerData.customerNumber),
        this.zapiService.getUpline(customerData.customerNumber),
      ]);
    }

    return {
      averageMonthlyOrderValue: DatasheetHelper.calculateAverageMonthlyOrderValue(customerData.invoices),
      averageOrdersPerMonth: DatasheetHelper.calculateAverageMonthlyOrders(customerData.invoices),
      customerNumber: customerData.customerNumber,
      customerSince: customerData.created ?? ``,
      fairScore,
      generation: upline && upline.length > 0 ? upline[0].generation : undefined,
      newsletter: customerData.baseData.newsletter,
      partnerSince: customerData.partnerSince,
    };
  }

  public async getOrders(filter: IDatasheetOrdersFilter & { customerNumber: number }, page: number): Promise<{ orders: IDataSheetOrder[]; totalOrders: number }> {
    const response = await this.zapiService.getDatasheetOrders(
      TransformHelper.transformDatasheetOrdersFilterWithCNToApiDatasheetOrdersFilter(filter),
      (page - 1) * config.datasheet.orders.ordersPerPage,
      config.datasheet.orders.ordersPerPage,
    );
    return {
      orders: TransformHelper.transformApiDatasheetOrdersToDatasheetOrders(response.orders),
      totalOrders: response.totalOrders,
    };
  }
}
